<template>
   <div class="font-size-14">
    <yxt-form ref="ruleForm" label-width="100px">
      <!-- 考试限制 -->
      <yxt-form-item class="color-gray-9" prop="entryTime" :label="$t('pc_biz_ote_lbl_marker')">
        <yxt-radio-group v-model="markerData.markType" :direction="'row'" :disabled="status !== 0">
          <yxt-radio :label="3">{{ $t('pc_biz_ote_lbl_markerset1') }}</yxt-radio>
          <yxt-radio :label="2">{{ $t('pc_biz_ote_lbl_markerset2') }}</yxt-radio>
          <yxt-radio :label="0">{{ $t('pc_biz_ote_lbl_markerset3', [50]) }}</yxt-radio>
        </yxt-radio-group>
        <div class="ml24">
          <div class="mt5" v-if="markerData.markType === 0">
            <yxt-button :disabled="status !== 0" type="primary" @click="addMarker()">{{ $t('pc_biz_ote_btn_addpeople') }}</yxt-button>
          </div>
          <div class="mt10" v-if="markerData.markType === 0">
            <div class="yxtbiz-exam-arrange__selection">
              <yxt-scrollbar :fit-height="true">
                <yxt-tag
                  @close="deleteItem(item)"
                  class="mr5"
                  size="small"
                  type="info"
                  style="margin-bottom:5px"
                  closable
                  :key="item.id"
                  v-for="item in markers"
                  ><yxt-svg class="mr5 v-mid"  width="14px" height="14px" :icon-class="'person-center'" /><span class="yxtbiz-user-selector-tag"><yxtbiz-user-name :name='item.fullname' /></span></yxt-tag>
              </yxt-scrollbar>
            </div>
            <!-- <yxt-input :disabled="status !== 0" type="textarea" rows="4" v-model="markerNames" autocomplete="off" :readonly="true"></yxt-input> -->
          </div>
        </div>
      </yxt-form-item>
    </yxt-form>
    <select-users v-if="selectUsersDialogData.dialogVisible" :functionCode="functionCode" :dataPermissionCode="dataPermissionCodes.selectMarker" :states='selectUsersDialogData' @selectUsersCallback="selectUsersCallback" @closeSelectDrawer="closeSelectDrawer"></select-users>
  </div>
</template>
<script>
import { getExamMarker } from '../service'; // , setMarkMode, setDesignMarker
import selectUsers from '../user/selectUsers';
import {
  Form,
  FormItem,
  Tag,
  Scrollbar,
  RadioGroup,
  Radio
} from 'yxt-pc';
import UserName from 'yxt-biz-pc/packages/user-name';

export default {
  name: 'arrangeMarkSetting',
  components: {
    selectUsers,
    YxtForm: Form,
    YxtFormItem: FormItem,
    YxtScrollbar: Scrollbar,
    YxtTag: Tag,
    YxtRadioGroup: RadioGroup,
    YxtRadio: Radio,
    YxtbizUserName: UserName
  },
  props: {
    id: {
      type: String,
      required: false
    },
    arrange: {
      type: Object,
      default: () => { return {}; }
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCodes: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      attendType: 0,
      needCheck: 0,
      status: 0,
      selectUsersDialogData: {
        title: '',
        dialogVisible: false,
        tabs: [ 'persons', 'userGroup', 'advance' ],
        users: []
      },
      loadedMarker: false,
      markerIds: [],
      markers: [],
      markerNames: '',
      markerData: {
        id: '',
        markType: 3, // 批阅人类型。0指定批阅人批阅；1自己批阅；2直接上级批阅；3直属领导批阅；4定向批阅；
        markers: []
      }
    };
  },
  created() {
    this.ruleFormStr = JSON.stringify(this.submitForm());
  },
  methods: {
    getMarker() {
      this.loadedMarker = true;
      getExamMarker(this.id).then(res => {
        // this.loadedMarker = true;
        this.markerData = res;
        if (res.markers) {
          this.markerIds = res.markers.map(function(v) { return v.id; });
          this.markerNames = res.markers.map(function(v) { return v.fullname; }).join(';');
          this.markers = res.markers;
        }
        this.ruleFormStr = JSON.stringify(this.submitForm());
      }).catch(this.handleError.bind(this));
    },
    addMarker() {
      this.selectUsersDialogData.title = this.$t('pc_biz_ote_tit_selectprincipal');
      this.selectUsersDialogData.users = this.markerData.markers;
      this.showDialog();
    },
    deleteItem(item) {
      this.markers = this.markers.filter((m) => {return m.id !== item.id;});
      this.selectUsersDialogData.users = this.markerData.markers;
      this.selectUsersCallback(this.markers);
    },
    showDialog() {
      this.selectUsersDialogData.dialogVisible = true;
    },
    closeSelectDrawer() {
      this.selectUsersDialogData.dialogVisible = false;
    },
    selectUsersCallback(users) {
      this.markerIds = users.map(function(v) { return v.id; });
      if (this.markerIds.length > 0) {
        this.markerData.markers = JSON.parse(JSON.stringify(users, ['id', 'fullname']));
        this.markerNames = users.map(function(v) { return v.fullname; }).join(';');
        this.markers = users;
      }
    },
    submitForm(isSave) {
      let ruleForm = {
        'markType': this.markerData.markType,
        'markers': this.markerData.markType === 0 ? this.markerIds : []
      };
      if (isSave && this.markerData.markType === 0 && (!this.markerIds || this.markerIds.length === 0)) {
        this.$message({
          type: 'error',
          message: this.$t('pc_biz_ote_msg_markernotnull')
        });
        return false;
      }
      return ruleForm;
      // this.setMarker();
    },
    // setMarker() {
    //   const type = this.markerData.markType;
    //   // 保存批阅类型
    //   setMarkMode(this.id, type).then(res => {
    //     if (type === 0) {
    //       // 保存指定批阅人
    //       setDesignMarker(this.id, this.markerIds).then(res => {
    //         this.$emit('next', 2, true);
    //       }).catch(this.handleError.bind(this));
    //     } else {
    //       this.$emit('next', 2, true);
    //     }
    //   }).catch(this.handleError.bind(this));
    // },
    handleError(error) {
      error = error.error;
      let msg = error.message;
      this.$message({
        message: msg,
        type: 'error'
      });
    },
    checkChange() {
      let ruleFormStrNew = JSON.stringify(this.submitForm());
      return this.ruleFormStr !== ruleFormStrNew;
    }
  },
  watch: {
    arrange(res) {
      this.markerData.markType = res.markType;
      this.attendType = res.attendType;
      this.needCheck = res.needCheck;
      this.status = res.id ? res.status : 0;
      if (this.markerData.markType === 0) {
        this.getMarker();
      }
      this.ruleFormStr = JSON.stringify(this.submitForm());
    }
  }
};
</script>
